import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { App } from './App';
import { store } from './redux/store';
import 'normalize.css/normalize.css';
import 'react-toastify/dist/ReactToastify.css';
import 'rc-tooltip/assets/bootstrap.css';
import 'rc-slider/assets/index.css';
import './index.scss';

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <ToastContainer />
      <App />
    </Provider>
  </Router>,
  document.getElementById('root'),
);
